import { render } from "./ReactivateProfile.vue?vue&type=template&id=67497df4&scoped=true"
import script from "./ReactivateProfile.vue?vue&type=script&lang=js"
export * from "./ReactivateProfile.vue?vue&type=script&lang=js"

import "./ReactivateProfile.vue?vue&type=style&index=0&id=67497df4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67497df4"

export default script